// @flow
import createStore from "shared/store/createStore"
import reducers from "store/reducers"

export default createStore({ reducers })
